export function stockSelection(item = {}) {
  if (item.market === 'index') {
    const code = String(item.symbol || item.code || item.full_code || '').trim()
    return { market: 'index', symbol: code, code, name: item.name || item.prod_name || '' }
  }
  // US catalog symbols can carry exchange suffixes (e.g. AAPL.OQ);
  // full_code is the canonical quote/order identifier.
  const symbol = String(/^us/i.test(item.full_code || '') ? item.full_code : item.symbol || item.full_code || '').trim()
  const lower = symbol.toLowerCase()
  let market = String(item.market || '')
  if (/^hk/.test(lower) || /\.hk$/.test(lower)) market = 'hk'
  else if (/^us/.test(lower) || /\.(us|usa)$/.test(lower)) market = 'us'
  else if (/^(sh|sz|bj)/.test(lower) || /\.(sh|sz|bj)$/.test(lower)) market = 'cn'
  if (!['cn', 'hk', 'us', 'index'].includes(market)) market = 'cn'
  if (market === 'us' && symbol) {
    const ticker = symbol.replace(/^us/i, '').replace(/\.(us|usa)$/i, '').replace(/\.(N|OQ|AM)$/i, '').toUpperCase()
    return { market, symbol: ticker + '.us', code: 'us' + ticker, name: item.name || item.prod_name || '' }
  }
  const code = market === 'hk' && symbol ? 'hk' + lower.replace(/^hk|\.hk$/g, '').padStart(5, '0') : symbol
  const chartSymbol = market === 'hk' && code ? code.slice(2) + '.hk' : market === 'cn' && /^(sh|sz|bj)\d{6}$/.test(lower) ? lower.slice(2) + '.' + lower.slice(0, 2) : symbol
  return { market, symbol: chartSymbol, code, name: item.name || item.prod_name || '' }
}
